module.exports = "img/photo30.55b833.jpeg";